export const redirectToSignIn = () => {
  window.location.href = `/identity${window.location.search}`;
};

export const isBetMGMClient = (client: string) => client === 'bet_mgm';
